var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOwnerHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.125 8.281V17.5a.625.625 0 0 0 .625.625H7.5v-5.312a.937.937 0 0 1 .938-.938h3.124a.94.94 0 0 1 .938.938v5.312h3.75a.624.624 0 0 0 .625-.625V8.281"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.75 10-8.325-7.969c-.195-.206-.652-.208-.85 0L1.25 10m14.375-3.008V2.5H13.75v2.695"
}))));
export default SvgIconOwnerHome;